import { render, staticRenderFns } from "./ListaCobrancas.vue?vue&type=template&id=5748aec5&"
import script from "./ListaCobrancas.vue?vue&type=script&lang=js&"
export * from "./ListaCobrancas.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports